export class Label {
}
